/* Reducers */
import { CounterReducer } from 'content/features/counter';
import AppReducer from 'content/app.reducer';
import { LoginReducer, RecoveryReducer, RegisterReducer } from 'content/features/authentication';
import { UserTasksReducer } from 'content/features/tasks';

const MainReducer = {
  app: AppReducer,
  login: LoginReducer,
  register: RegisterReducer,
  counter: CounterReducer,
  recovery: RecoveryReducer,
  userTasks: UserTasksReducer,
};

export default MainReducer;
